import style from "./style";

const CheckoutJS = props => {
  return (
    <div className={`${style["ptm-checkoutjs-container"]}`} style={{ display: props.show ? "block" : "none" }}>
      <div id="paytm-checkoutjs" style={{ overflow: 'hidden' }} className={`${style["ptm-checkoutjs-lg-wrapper"]}`} />
      
      {/* footer */}
      <div className={`${style["ptm-checkoutjs-footer"]}`}>
        <div className={`${style["ptm-checkoutjs-footer-container"]}`}>
          <div className={`${style["ptm-checkoutjs-f-i-container"]}`}>{props.children}</div>
        </div>
        <div className={`${style["ptm-checkoutjs-b-f-container"]}`}>
          <div className={`${style["b1-style"]}`} />
          <div className={`${style["b2-style"]}`} />
        </div>
      </div>
    </div>
  );
};
export default CheckoutJS;



// WEBPACK FOOTER //
// ./form/components/checkoutjs/index.js